import { useTranslation, Trans } from 'next-i18next'

export default function SDKSafeguardError() {
  const { t } = useTranslation()

  return (
    <div style={{ background: 'white', padding: 48, margin: 48 }}>
      <Trans i18nKey="SDKSafeguardError.installError" t={t}>
        Install Error: Please ensure you&apos;ve installed the campaign correctly using the
        instructions{' '}
        <a
          href="https://support.classy.org/s/article/embed-a-donation-form-on-your-website"
          title="Install an Embedded Donation Form"
        >
          here
        </a>
      </Trans>
    </div>
  )
}
